import { FormattedMessage } from "react-intl";
import classNames from "classnames/bind";
import { Card, CardContent, CardMedia } from "app/components/ui/Card/Card";
import { Image } from "app/components/ui/Image/Image";
import Typography from "app/pages/.shared/Typography/Typography";
import styles from "./UpcomingTripPlaceholder.module.scss";

const cx = classNames.bind(styles);

export type UpcomingTripPlaceholderProps = {
	/** Decorative illustration. */
	picture: string;
	/** `sizes` attribute of the illustration, as for the trip photos next to it. */
	pictureSizes: string;
};

/** Decorative "your next trip" card that fills an empty slot of the recently viewed trips row. Hide its slide from assistive technologies. */
export const UpcomingTripPlaceholder = ({
	picture,
	pictureSizes,
}: UpcomingTripPlaceholderProps) => (
	<Card variant="ghost" padding="sm">
		<CardMedia className={cx("upcoming-trip-placeholder__media")}>
			<Image src={picture} alt="" width={325} height={185} sizes={pictureSizes} />
		</CardMedia>
		<CardContent>
			<Typography variant="xl" isBold className={cx("upcoming-trip-placeholder__label")}>
				<FormattedMessage id="general.upcoming.trip.label" />
			</Typography>
		</CardContent>
	</Card>
);
